import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cn } from 'helpers/classnames';
import { changeLikeCount, changeLikeStatus, updateCustomerPostLikedStatus } from 'actions/influencer/influencerContent';
import FederatedLoginModal from 'components/account/FederatedLoginModal';
import { isAssigned } from 'actions/ab';
import { HYDRA_LIKE_POST } from 'constants/hydraTests';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';
import type { AppState } from 'types/app';

import css from 'styles/components/influencer/shoppablePosts/LikeButton.scss';

interface Props {
  postId: string;
  text?: string;
  isLiked: boolean;
  likeCount: number;
  onClick?: () => void;
}

export const LikeButton = (props: Props) => {
  const onLikeButtonClicked = () => {
    if (isCustomer) {
      dispatch(changeLikeCount(!isLiked));
      dispatch(changeLikeStatus(postId, !isLiked));
      dispatch(updateCustomerPostLikedStatus(postId, !isLiked));
    } else {
      setIsLoginModalOpen(true);
    }
  };
  const { postId, text, isLiked, likeCount = 0, onClick = onLikeButtonClicked } = props;
  const cookies = useSelector((state: AppState) => state.cookies);
  const allowLikeContent = useSelector(state => isAssigned(HYDRA_LIKE_POST, 1, state));
  const isCustomer = 'x-main' in cookies;
  const [isLoginModalOpen, setIsLoginModalOpen] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const [count, setCount] = useState<string>(likeCount.toString());

  const handleClose = () => {
    setIsLoginModalOpen(false);
  };

  useEffect(() => {
    setCount(likeCount >= 1000 ? `${Math.floor(likeCount / 1000)}k` : likeCount.toString());
  }, [likeCount]);

  return (
    allowLikeContent && (
      <div>
        <button type="button" onClick={onClick} className={cn(css.likeButton, isLiked ? css.likedButton : css.unLikedButton)}>
          {text}
          {count}
        </button>
        {isLoginModalOpen && <FederatedLoginModal isOpen={isLoginModalOpen} handleClose={handleClose} copy="" returnTo="" />}
      </div>
    )
  );
};
